// frontend/src/utils/safety.ts
// Lightweight profanity filter using 'bad-words' with a small extension list.
import Filter from 'bad-words';

const base = new Filter();
// Add a few custom words or app-specific variants if needed.
// Note: keep this generic and avoid listing explicit slurs here.
const extra: string[] = [
  'dummyword', // placeholder example; replace with project-specific banned terms
];
extra.forEach((w) => {
  try { base.addWords(w); } catch {}
});

export function containsOffensive(text?: string): boolean {
  if (!text) return false;
  try {
    return base.isProfane(String(text));
  } catch {
    return false;
  }
}
